import * as React from "react"
import { IconButton } from "@chakra-ui/react"
/* import { FaRegCopy } from "react-icons/fa" */

import { brandingSelector } from "../../../recoil/atoms/room"
import { useRecoilState, useRecoilValue } from "recoil"
import { TbArrowsDiagonal, TbArrowsDiagonalMinimize2 } from "react-icons/tb"

import { stopClientExpandingAtom } from "../../../recoil/atoms/layout/stopClientExpanding"

type ExpandIconProps = {
  backgroundColor?: string;
  fontSize?: string;
  height?: string;
}

const _ExpandIcon = ({ backgroundColor, fontSize, height } : ExpandIconProps) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const [isStopClientExpanding, setStopClientExpanding] = useRecoilState(
    stopClientExpandingAtom
  )

  const handleChangeExpandLayout = () => {
    setStopClientExpanding(prev => !prev)
  }

  return (
    <>
      <IconButton
        aria-label="copy-icon"
        fontSize={fontSize ?? "1.5rem"}
        width="1.5rem"
        minW="2rem"
        height={height ?? "1.5rem"}
        marginTop="auto"
        icon={
          isStopClientExpanding ? (
            <TbArrowsDiagonal />
          ) : (
            <TbArrowsDiagonalMinimize2 />
          )
        }
        onClick={handleChangeExpandLayout}
        color={roomStyles?.accessButtonTextColor ?? "#718096"}
        backgroundColor={backgroundColor ?? roomStyles?.accessButtonBackgroundColor ?? "gray.100"}
        _hover={{
          color: roomStyles?.accessButtonTextMouseoverColor ?? "#000",
          backgroundColor: backgroundColor ?? roomStyles?.accessButtonMouseoverColor ?? "#edf2f7"
        }}
        _focus={{}}
      />
    </>
  )
}

export const ExpandIcon = React.memo(_ExpandIcon)
